export default "__VITE_ASSET__Nzy7ZKRO__"